export const getters = {
    measurementsFrom(state) {
        return state.timeDiapason.from;
    },
    measurementsUntil(state) {
        return state.timeDiapason.until;
    },
};
